import React from 'react';
import PropTypes from 'prop-types';

import Button from 'shared/Button';

function Switch({ value, options, onChange }) {
  return (
    <div className="switch">
      {options.map((option) => (
        <Button
          key={option.value}
          label={option.label}
          className={`${option.value === value ? 'active' : ''}`}
          onClick={() => { onChange(option.value); }}
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
}

Switch.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default Switch;
